import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientService } from './client.service';
import { MindMapModel } from './mindmap.service';

export interface MindMapVersionModel {
  id: number;
  mindMapId: number;
  versionNumber: number;
  changeSummary: string | null;
  userName?: string | null;
  data?: string | null;
  createdAt?: string | null;
}

export interface MindMapVersionListParams {
  mindMapId: number;
  workspaceId: number;
}

@Injectable({ providedIn: 'root' })
export class MindMapVersionService {
  private readonly client = inject(ClientService);

  get(id: number): Observable<MindMapVersionModel> {
    return this.client.get<MindMapVersionModel>(`mindmap-version/${id}`);
  }

  list(params: MindMapVersionListParams): Observable<MindMapVersionModel[]> {
    const query = new URLSearchParams({
      mindMapId: String(params.mindMapId),
      workspaceId: String(params.workspaceId),
    });

    return this.client.get<MindMapVersionModel[]>(
      `mindmap-version?${query.toString()}`,
    );
  }

  restore(id: number): Observable<MindMapModel> {
    return this.client.post<MindMapModel, null>(
      `mindmap-version/${id}/restore`,
      null,
    );
  }

  create(payload: MindMapVersionModel): Observable<MindMapVersionModel> {
    return this.client.post<MindMapVersionModel, MindMapVersionModel>(
      'mindmap-version',
      payload,
    );
  }

  update(payload: MindMapVersionModel): Observable<MindMapVersionModel> {
    return this.client.put<MindMapVersionModel, MindMapVersionModel>(
      'mindmap-version',
      payload,
    );
  }

  delete(id: number): Observable<MindMapVersionModel> {
    return this.client.delete<MindMapVersionModel>(`mindmap-version/${id}`);
  }
}
